<div class="flex flex-col flex-1 justify-center items-center">
	<div class="empty-state-image">
		<img
			src="assets/images/empty-states/mortgages.svg"
			style="max-width: 500px"
		/>
	</div>
	<h3 class="mt-10">No PIN</h3>
	<p class="mt-3">Looks like you haven't purchased a PIN yet.</p>
	<div class="mt-5">
		<app-button
			[icon]="ICON.SEARCH"
			size="small"
			(click)="goToTitleSearch()"
			[testHook]="testHooks.SearchForAPinButton"
			>Search for a PIN</app-button
		>
	</div>
</div>
